<div class="mainContainer">

    <div class="filter_show">
        <h2 class="log_track">Mess Inventory Details</h2>
    </div>
    <div class="mess-box">
        <div class="icon_flex">
            <p class="stock_title">Stock Date<span style="color: red;">*</span> :</p>
            <input matInput [matDatepicker]="mydate" (click)="mydate.open()" (dateChange)="onStockDateChange($event)"
                class="form-control form-date" placeholder="Select Stock Date" />
            <mat-datepicker-toggle matSuffix [for]="mydate" class="datepic">
            </mat-datepicker-toggle>
            <mat-datepicker #mydate></mat-datepicker>
            <p class="stock_title">Mess/Kitchen<span style="color: red;">*</span> :</p>
            <!-- <select class="cctv_size" id="" [(ngModel)]="KitchenType" >
                <option value="" class="select" selected disabled hidden >Select
                    Kitchen Type</option>
                <option *ngFor="let item of allocatedCampusList" [value]="item.buildingId">
                    {{item.buildingName}}
                </option>
            </select> -->

            <div class="dropdown">
                <a class="btn  dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false"
                    (click)="focusSearchInput()">
                    <ng-container>
                        <span class="sidebar">{{ selectedBuildingName ? selectedBuildingName : 'Select Kitchen Type' }} </span>
                    </ng-container>
                </a>
                <ul class="dropdown-menu campus-details">
                    <li class="d-flex align-items-center">
                        <input type="text" class="form-control form-search" placeholder="Search..." #searchInputcampus
                            (keyup)="campusSearch($event)" [(ngModel)]="campusQuery" />
                    </li>
                    <li class="list_campus">
                        <ng-container *ngFor="let data of filteredCampusDetails">
                            <ul class="overall_Detail" (click)="selectCampus(data?.buildingName,data?.buildingId)"
                                [class.selected]="selectedBuildingID===data?.buildingId">
                                <li class="campus_right">{{data?.buildingName}}</li>
                                <li>
                                    <span *ngIf="selectedBuildingID===data?.buildingId"><i
                                            class="fa fa-check right_check"></i></span>
                                </li>
                            </ul>
                        </ng-container>
                    </li>
                </ul>
            </div>

        </div>

        <!-- EXCEL UPLOAD -->

        <div class="upload-box">
            <input type="file" (change)="onFileSelected($event)" accept=".xls,.xlsx,.csv" hidden #fileInput />
            <div class="upload-area" (click)="fileInput.click()">
                <b>Browse Files</b>
                <p>Drag and drop Excel files here</p>
                <small class="text-muted">
                    (Only Upload Excel: .xls, .xlsx, .csv)
                </small>
            </div>
        </div>
        <!-- Show selected file -->
        <div *ngIf="fileName" class="selected-file">
            <b>Selected File:</b> {{ fileName }}
        </div>
        <!-- submit  -->
        <div class="sub">
            <button class="submit_title" (click)="submit()">Submit</button>
        </div>
    </div>
</div>

<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>